import React, { useState,useEffect } from 'react';
import NxtLayout from '../../composite/nxt-layout';
import IxTxtBox from '../../basic/ix-txt-box';
import IxButton from '../../basic/ix-button';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import NxtTopBar from '../../basic/nxt-top-bar';
import Grid from '@material-ui/core/Grid';
import { TextField, Typography } from '@material-ui/core';
import RlTimepicker from '../../composite/rl-time-picker';
import moment from "moment"
import {setOrder, setCart} from '../../../actions/cart';
import { useDispatch } from 'react-redux';

const PickupTimeHome = ({ 
 history,
 pickupTimeStore,
 fetchPickupTimeRange,
 setSelectedPickupTime,
 appState,
}) => {

  const [pickupTime, setPickupTime] = useState([]);
  const[selectTime, setSelectTime]=useState("")
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch()

  const handleContinueBtnAction = () => {
    setSelectedPickupTime(selectTime)
    history.push(`/recommended`);
  };

  const checkAgainstCurrentTime = (timeList)=>{
    let currentTime = moment()
     let timelist = timeList.filter((value,index)=>(
      value.isOpen&&currentTime.valueOf() < moment(value.time24, 'hh:mm').valueOf()
     ))
     setPickupTime(timelist)
  }
 
  const callPickupTimeRangeApi =async(data)=>{
    await fetchPickupTimeRange(data)
  }
  useEffect(()=>{
    if(appState &&appState.session){
      callPickupTimeRangeApi({
        branchId:appState.session.data.branch.id,
        companyId:appState.session.data.branch.companyId
      })
    }
     dispatch(setOrder(null))
     dispatch(setCart([]))
    
  },[])
  useEffect(()=>{
    if(
      pickupTimeStore && 
      pickupTimeStore.pickupTimeRange && 
      pickupTimeStore.pickupTimeRange.data && 
      pickupTimeStore.pickupTimeRange.data.length !==0 
      ){
        checkAgainstCurrentTime(pickupTimeStore.pickupTimeRange.data)
      }
  },[pickupTimeStore.pickupTimeRange.data])
  return (
    <NxtLayout
      header={
        <NxtTopBar background={'white'} marginLeft={true}>
          <Typography variant="h6">{t('pickupTime')}</Typography>
        </NxtTopBar>
      }
      footer={
        pickupTime && 
        pickupTime.length !==0 ?
        <IxButton
          variant="contained"
          fullWidth
          color="primary"
          className={classes.continueButton}
          onClick={handleContinueBtnAction}
        >
          {t('Continue')}
        </IxButton>:
        null
      }
    >
      <Grid container className={classes.pickupLogo}>
        <div className={classes.logoWrapper}>
          <div className={classes.logoRadius}>
            <AccessTimeIcon
              style={{ fontSize: 60, color: 'rgba(0, 0, 0,0.24)' }}
            ></AccessTimeIcon>
          </div>

          <IxTxtBox
            className={classes.pickupText}
            primary={t('choosePickUpTime')}
            primaryClassName={classes.primaryText}
          ></IxTxtBox>
          <IxTxtBox
            secondary={t('pickup-time-paragraph')}
            secondaryClassName={classes.secondaryText}
          ></IxTxtBox>

          <IxTxtBox
            secondary={t('pickup-time-paragraph2')}
            secondaryClassName={classes.secondaryText}
          ></IxTxtBox>
           {pickupTime && 
           pickupTime.length !==0 ?
          <RlTimepicker 
          timeList={pickupTime} 
          setSelectTime={setSelectTime}
          />
          :
          <Typography className={classes.message}>

            {t('noSlotAvailable')}
            </Typography>
           }
        </div>
      </Grid>
    </NxtLayout>
  );
};

export default PickupTimeHome;
